import LayoutActividad from "../../../components/LayoutActividad";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faComments } from "@fortawesome/free-solid-svg-icons";
import { modulo7 } from "../../../routes/Module7";
import Sidebar from "../Sidebar";
import GuiaDocente from "../../../components/GuiaDocente";
import Modulo7Act5 from "../../../DnD/modulo7Act5";
import AudioPlayer from "../../../audioPlayer/AudioPlayer";
import Audio from "../../../audios/modulo7/Actividad 5.mp3";

const Actividad5 = () => {
  const infoUnidad = modulo7.content[0];
  const infoAct = modulo7.content[0].activities[4];
  const crumbs = [
    {
      title: modulo7.title,
      url: "/" + modulo7.url,
    },
    {
      title:
        modulo7.content.length === 1
          ? `${infoAct.name}`
          : `${infoUnidad.name} > ${infoAct.name}`,
      url: infoAct.path,
    },
  ];

  const pages = {
    titleNext: `${modulo7.content[0].activities[5].name}`,
    linkNext: `${modulo7.url}/${modulo7.content[0].path}/${modulo7.content[0].activities[5].path}`,
    titlePrev: `${modulo7.content[0].activities[3].name}`,
    linkPrev: `${modulo7.url}/${modulo7.content[0].path}/${modulo7.content[0].activities[3].path}`,
  };

  const metadata = {
    color: modulo7.color,
    title: `${modulo7.title} - ${infoAct.name}`,
    name: modulo7.title,
  };

  const items = [
    <div className="selectable btn btn-blue shadow mx-3 my-1">origen </div>,
    <div className="selectable btn btn-blue shadow mx-3 my-1">
      condición económica{" "}
    </div>,

    <div className="selectable btn btn-blue shadow mx-3 my-1">sexo </div>,
    <div className="selectable btn btn-blue shadow mx-3 my-1">raza </div>,
    <div className="selectable btn btn-blue shadow mx-3 my-1">idioma </div>,
    <div className="selectable btn btn-blue shadow mx-3 my-1">religión </div>,
  ];

  return (
    <LayoutActividad
      pages={pages}
      crumbs={crumbs}
      sidebar={<Sidebar />}
      modulo={metadata}
    >
      <p>
        <small className={`c-${modulo7.color} hat-text`}>
          <FontAwesomeIcon icon={faComments} /> Dialogamos
        </small>
      </p>

      <h2 className="mb-5">{infoAct.name}</h2>
          <AudioPlayer track={Audio} />
      <ul className="mb-5">
        <li>
          Ya vimos que la Constitución del Perú dice que todos somos iguales
          ante la ley.
        </li>
        <li>
        Trabaja con un compañero, compañera o familiar. Lean lo que dice cada personaje
          y decidan a qué tipo de igualdad se refieren.
        </li>
      </ul>

      <Modulo7Act5 items={items} />
      <GuiaDocente>
        <p>
          Lea las indicaciones. Retome el concepto de discriminación que se vio
          antes. Observen las imágenes y ayude con las respuestas. Las
          respuestas son igualdad de idioma, raza, sexo, origen, religión,
          condición económica. Destaque la importancia de la igualdad ante la
          ley.
        </p>
      </GuiaDocente>
    </LayoutActividad>
  );
};

export default Actividad5;
